<template>
  <v-alert
    style="position: fixed; right: 0px; left: 0px; margin-right: auto; margin-left: auto; bottom: 30px;"
    :value="isShow"
    class="ma-3"
    dense
    :class="{ 'alert-mobile': $mobileDetect.phone() || $mobileDetect.tablet()}"
    transition="slide-y-reverse-transition"
  >
    <v-row align="center">
      <v-col class="grow text-center">
        <a
          class="alert-link"
          @click="privacyModalOpen = true"
        >{{ $t('privacy.privacyPolicy') }}</a> - {{ $t('privacy.useCookies') }}
      </v-col>
      <v-col class="shrink">
        <v-btn
          rounded
          @click="acceptPolicy"
        >
          {{ $t('privacy.ok') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog
      v-model="privacyModalOpen"
      persistent
      width="600"
      content-class="dialog-radius"
    >
      <v-card>
        <v-card-title class="headline">
          <v-spacer />
          {{ $t('privacy.privacyPolicy') }}
          <v-spacer />
        </v-card-title>
        <v-card-text
          class="pa-0"
          style="overflow-y: auto; max-height: 410px"
        >
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                1. Présentation du site
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <p>
                      Le site est la propriété de la société NOVACEL OPTHALMIQUE, Société par actions simplifiée au capital de 444.000,00 immatriculée au Registre du Commerce et des Sociétés de Soissons sous le n° 394 620 298, dont le siège social est situé au 2 Centre d’Activités de La Moiserie BP 80160, 02404 Château Thierry Cedex, France
                    </p>
                    <p>
                      Tél : <a href="tel:+33323838888">03 23 83 88 88</a>
                    </p>
                    <p>
                      Email : <a href="mailto:rgpd@novacel-optical.com">rgpd@novacel-optical.com</a>
                    </p>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                2. Mise en garde générale
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <p>
                      NOVACEL OPHTALMIQUE, propriétaire de ce site, s’efforce d’assurer au mieux de ses possibilités l’exactitude et la mise à jour des informations diffusées sur ce site, au moment de leur mise en ligne.
                    </p>
                    <p>
                      Toutefois, NOVACEL OPHTALMIQUE :
                      <ul>
                        <li>Ne garantit en aucune façon l’exactitude, la précision ou l’exhaustivité des informations mises à disposition sur ce site</li>
                        <li>Se réserve le droit de modifier ou de corriger le contenu des documents publiés sur ce site à tout moment et sans préavis</li>
                      </ul>
                    </p>
                    <p>
                      En conséquence, NOVACEL OPHTALMIQUE décline toute responsabilité :
                      <ul>
                        <li>Pour toute interruption du site ou survenance de bogues,</li>
                        <li>Pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site,</li>
                        <li>Pour tout dommage résultant d’une intrusion frauduleuse d’un tiers y compris lorsque celle-ci pourrait entraîner une modification des informations mises à disposition sur le site</li>
                        <li>Et plus généralement pour tout dommage, direct ou indirect, quelles qu’en soient les causes, origines, natures ou conséquences, provoqué à raison de l’accès de quiconque au site ou de l’impossibilité d’y accéder, de même que l’utilisation du site et/ou du crédit accordé à une quelconque information provenant directement ou indirectement de ce dernier.</li>
                      </ul>
                    </p>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                3. Respect des droits de propriété intellectuelle
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <p>Le site constitue une œuvre de l’esprit protégé par les lois sur la propriété intellectuelle. Sauf mention contraire, les droits de la propriété intellectuelle sur les documents contenus dans le site et chacun des éléments créés pour ce site sont la propriété exclusive de NOVACEL OPHTALMIQUE, celle-ci ne concédant aucune licence, ni autre droit que celui de consulter le site.</p>
                    <p>La reproduction de tout document publié sur le site est seulement autorisée à des fins exclusives d’information pour un usage personnel et privé, toute reproduction et toute utilisation de copies réalisées à d’autres fins étant expressément interdite.</p>
                    <p>Les marques, brevets, logos ou autres droits de propriété intellectuelle cités sur ce site sont la propriété de NOVACEL OPHTALMIQUE ou font l’objet d’une autorisation d’utilisation. Aucun droit ou licence ne saurait être attribué sur quelconque de ces éléments sans l’autorisation écrite de NOVACEL OPHTALMIQUE ou du tiers, détenteur des droits.</p>
                    <p>Ce site respecte le droit d’auteur. Tous les droits des auteurs des œuvres protégées reproduites et communiquées sur ce site, sont réservés. Sauf autorisation, toute utilisation des œuvres autres que la reproduction et la consultation individuelles et privées sont interdites.</p>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                4. Liens vers d’autres sites
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <p>Les liens figurant sur ce site vers d’autres sites affiliés et non-affiliés sont donnés à titre informatif.</p>
                    <p>Les liens vers tous les sites non-affiliés ne sauraient impliquer NOVACEL OPHTALMIQUE en aucune manière : adhésion au contenu des pages Web vers lesquels pointent ces liens, aux produits, publicités et tout élément ou service présentés sur ces sites.</p>
                    <p>La sécurité informatique des pages vers lesquelles certains liens figurant sur le site peuvent pointer n’est pas garantie. Il vous importe de prendre les précautions nécessaires à cet égard, NOVACEL OPHTALMIQUE déclinant toute responsabilité pour tout dommage direct ou indirect, quelles qu’en soient les causes, origines, natures ou conséquences provoquées à raison de l’accès à d’autres sites.</p>
                    <p>Nous vous rappelons que les sites non-affiliés sont soumis à leurs propres conditions d’utilisation.</p>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                5. Protection des données personnelles
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <p>Les informations vous concernant sont enregistrées et traitées en toute confidentialité par NOVACEL OPHTALMIQUE. Toute information personnelle que vous serez amené à transmettre à NOVACEL OPHTALMIQUE est soumise aux dispositions de la loi n° 78-17 Informatique et Libertés du 6 janvier 1978 modifiée et transposée selon le nouveau cadre juridique européen sur le protection des données personnelles conformément au règlement 2016/679. A ce titre, vous disposez d’un droit d’accès, de rectification, et de suppression des informations personnelles vous concernant que vous pouvez exercer à tout moment en adressant un courrier à l’adresse suivante :</p>
                    <p>
                      <a
                        href="https://www.google.fr/maps/place/Novacel+Ophtalmique/@49.0654143,3.3864225,17z/data=!3m1!4b1!4m12!1m6!3m5!1s0x47e8e8a9045962f1:0x438c64cd13ba4eba!2sNovacel+Ophtalmique!8m2!3d49.0654108!4d3.3886112!3m4!1s0x47e8e8a9045962f1:0x438c64cd13ba4eba!8m2!3d49.0654108!4d3.3886112"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        NOVACEL OPHTALMIQUE<br>
                        Direction Marketing<br>
                        2 Centre d’Activités de La Moiserie BP 80160 <br>
                        02404 Château Thierry Cedex, France
                      </a>
                    </p>
                    <p>
                      Tél : <a href="tel:+33323838888">03 23 83 88 88</a>
                    </p>
                    <p>
                      Email : <a href="mailto:rgpd@novacel-optical.com">rgpd@novacel-optical.com</a>
                    </p>
                    <p>NOVACEL OPHTALMIQUE doit conserver tout document émis ou reçu dans l’exercice de son activité pendant certaines durées minimales. Ces délais de prescription, pendant lesquels l’administration peut mener des contrôles a posteriori, varient en fonction de la nature des papiers à conserver et des obligations légales qui s’y rapportent.</p>
                    <p>
                      Pour tout renseignement, consultez <a
                        target="_blank"
                        href="https://www.service-public.fr/professionnels-entreprises/vosdroits/F10029"
                      >le site du service public</a>
                    </p>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                6. Respect des réglementations
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <p>Le site est mis en place par NOVACEL OPHTALMIQUE. Les internautes ayant accès au site depuis d’autres endroits que la France, doivent s’assurer du respect des lois localement applicables.</p>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                7. Modifications de la Politique de Confidentialité
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <p>NOVACEL OPHTALMIQUE se réserve le droit de modifier ou de compléter la présente Politique de Confidentialité à tout moment et sans préavis. C’est pourquoi nous vous invitons à la consulter régulièrement.</p>
                    <p>Ce site fait l’objet d’une déclaration à la Commission Nationale de l’Informatique et des Libertés, en application à la loi française du 6 janvier 1978.</p>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            rounded
            text
            @click="privacyModalOpen = false"
          >
            {{ $t('app.close') }}
          </v-btn>
          <v-btn
            v-if="$store.state.privacy"
            color="primary"
            rounded
            outlined
            @click="acceptPolicy"
          >
            {{ $t('privacy.accept') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-alert>
</template>
<script>
  export default {
    name: 'PrivacyAlertApp',
    data () {
      return {
        isOpen: false,
      }
    },
    computed: {
      isShow: {
        get () {
          return this.$store.state.privacy
        },
      },
      privacyModalOpen: {
        get () {
          return this.$store.state.modalPrivacy
        },
        set (value) {
          return this.$store.dispatch('setModalPrivacy', value)
        },
      },
    },
    created () {
      setTimeout(
        function () {
          this.isOpen = true
        }.bind(this),
        500,
      )
    },
    methods: {
      acceptPolicy () {
        this.privacyModalOpen = false
        this.$store.dispatch('setPrivacy', false)
        localStorage.setItem('privacyOk', 'false')
      },
    },
  }
</script>
<style scoped>
.v-alert {
  z-index: 10!important;
  max-width: 900px;
  height: auto;
  margin: 0 auto !important;
  background-color: rgba(51, 140, 198, 0.57) !important;
  font-size: 20px;
}
.alert-link {
  text-decoration: underline;
  color: white;
  font-weight: bold;
}
.alert-mobile {
  right: 10px!important;
  left: 10px!important;
}
</style>
